import React, {useState, useContext, useEffect, useMemo, useCallback, useReducer} from 'react'
import { useTranslation } from "react-i18next";
import {GetAlertsComponent,setObjectByPath, getConstantTextFields, validateConstantValues, translateType, colorVelvet} from "./utils"
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import MenuItem from '@material-ui/core/MenuItem';
import InputMask from "react-input-mask";
import RulesContext from "../../../../context/rules-context"
import AuthContext from '../../../../context/auth-context';
import _ from "lodash"
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@mui/material/Button';
import TimeDeltaTextField from './Components/TimeDeltaTextField';
import Input from '@material-ui/core/Input';
import Menu from '@material-ui/core/Menu';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Checkbox from '@material-ui/core/Checkbox';
import VariableWhiteIcon from "../../../../assets/rulesIcon/variable_white.svg"
import ConstantNumberWhite from "../../../../assets/rulesIcon/constant_number_white.svg"
import RestoreWhite from "../../../../assets/rulesIcon/restore_white.svg"
import brIcon from '../../../../assets/br.svg'
import usIcon from '../../../../assets/us.svg'
import moment from 'moment';
import { Dialog, Typography } from '@mui/material';
import axios from 'axios';
import { dataFetchReducer } from "../../../Utils/requestUtils";
import { trimNestedObject } from '../../../Utils/utils'
import {
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material'

export function EventFieldCounterBox (props) {
    const { t } = useTranslation();
    let {node} = props
    let {read_only} = props
    let {handleConfigurationOpen} = props
    let {handleNodeRemove} = props
    let helperString = "";


    const helperNode = _.cloneDeep(node)
    nodeToV2(helperNode)
    const mappings = helperNode.node.properties.target_event_type?.field_mappings || []
    if (helperNode.node.properties.fields && helperNode.node.properties.fields.length > 0) {
        helperString = helperString + helperNode.node.properties.fields.reduce((acc, field, idx, src) => {
            let event = mappings.filter(rule => rule.path === field.target_field_path)[0]
            let description = (event || {description:""}).description
            if (idx === 0) acc = acc + description
            else if (idx === src.length -1 && src.length > 1) acc = acc + " e " + description
            else acc = acc + ", " + description
            return acc
        }, "")
    }

    function formatTimedelta(timedelta) {
        const duration = moment.duration(timedelta);

        const years = duration.years();
        const months = duration.months();
        const days = duration.days();
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        let formattedString = '';

        if (years > 0) {
            formattedString += `${years} ${t('years')}`;
        }

        if (months > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${months} ${t('months')}`;
        }

        if (days > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${days} ${t('days')}`;
        }

        if (hours > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${hours} ${t('hours')}`;
        }

        if (minutes > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${minutes} ${t('minutes')}`;
        }

        if (seconds > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${seconds} ${t('seconds')}`;
        }

        return formattedString.trim();
    }

    return (
        <div>
            {!read_only ?
                <div style={{display:"flex", alignItems: "center"}}>
                    <div
                        style={{display:"flex", width:"100%", cursor:"pointer", margin: "0px"}}
                        onClick={() => handleConfigurationOpen(helperNode)}
                    >
                        <div style={{display: "flex",flexDirection: "column",margin: "auto 0px"}}>
                            <div className={["normalText","normalMediumSize"].join(" ")}>
                            {t("Contar")} {t(helperString)}
                            </div>
                            <div className={["normalText","normalSmallSize"].join(" ")}>
                            {helperNode.node.properties.timedelta_value
                            ?
                            t("Nos últimos ") + formatTimedelta(helperNode.node.properties.timedelta_value)
                            :
                            t("Em todo o histórico")}
                            </div>
                        </div>
                        {(helperNode.node.alerts || []).length > 0?
                        <GetAlertsComponent alerts={helperNode.node.alerts} />  : null}
                    </div>
                    <IconButton style={{width: 32, height: 32}} aria-label="duplicate" onClick={() => props.handleNodeDuplication(helperNode)}>
                        <ContentCopyIcon style={{width: 20, height: 20}} />
                    </IconButton>
                    <IconButton style={{width: 32, height: 32}} aria-label="close" onClick={() => handleNodeRemove(helperNode)}>
                        <CloseIcon style={{width: 20, height: 20}} />
                    </IconButton>
                </div>
                :
                <div style={{display:"flex"}}>
                    <div
                        style={{display:"flex", width:"100%", cursor:"pointer", margin: "0px"}}
                        onClick={() => handleConfigurationOpen(helperNode)}
                    >
                        <div style={{display: "flex",flexDirection: "column",margin: "auto 0px"}}>
                            <div className={["normalText","normalMediumSize"].join(" ")}>
                            {t("Contar")} {t(helperString)}
                            </div>
                            <div className={["normalText","normalSmallSize"].join(" ")}>
                            {helperNode.node.properties.timedelta_value
                            ?
                            t("Nos últimos ") + formatTimedelta(helperNode.node.properties.timedelta_value)
                            :
                            t("Em todo o histórico")}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export function EventFieldCounterConfiguration(props){

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 280,
            },
        },
    };

    const { t } = useTranslation();
    let {node} = props
    let {read_only} = props
    let {handleNodeChange} = props
    let {handleConfigurationClose} = props
    let {userVariables} = props
    let rulesList = useContext(RulesContext)
    let authContext = useContext(AuthContext)
    const { isRulePiece } = rulesList
    const box_settings = rulesList.boxes[node.node.type].settings
    let rule_company_key = (rulesList?.company_key && rulesList?.company_key !== "")? rulesList?.company_key : authContext.user_data?.company_key
    const { company } = useContext(RulesContext)
    const companyList = useMemo(() => (Array.isArray(company) ? company : []), [company])

    const getRegionFromEnvironment = (environment) => {
        if (environment === "production_sa" || environment === "production-sa") return "sa-east-1"
        else return "us-east-1"
    }
    const getEnvironmentFromRegion = (region, ruleEnvironment) => {
        if (region === "sa-east-1") return "production_sa"
        return ruleEnvironment === "sandbox" ? "sandbox" : "production"
    }
    const rule_event_type = useMemo(() => {
        let ruleEventType = rulesList?.event_type
        if (isRulePiece) {
            const firstCompanyEvent = companyList?.[0]?.company_events[0]
            ruleEventType = firstCompanyEvent?.field_mapping?.event_type
            rule_company_key = firstCompanyEvent?.company_key
        }
        else {
            const ruleCompany = companyList.find(comp => comp.company_key === rule_company_key)
            const ruleRegion = getRegionFromEnvironment(rulesList.environment)
            ruleEventType = ruleCompany?.company_events?.find(event =>
                event.field_mapping.event_type.enum === rulesList?.event_type
            && getRegionFromEnvironment(event.field_mapping.event_type.environment) === ruleRegion
            )?.field_mapping.event_type
        }

        return ruleEventType
    }, [rulesList.event_type, companyList, rule_company_key, rulesList.environment])

    let settingsFilters = (useContext(RulesContext).boxes[node.node.type].settings || {}).filters || []

    const [nodeState, setNodeState] = useState(() => {
        let new_node = _.cloneDeep(node)
        nodeToV2(new_node)

        const target_event_type = new_node.node.properties?.target_event_type ?? rule_event_type

        if (!target_event_type?.environment && target_event_type?.region) {
            target_event_type.environment = getEnvironmentFromRegion(target_event_type.region, rulesList.environment)
        }

        new_node.node.properties.target_company_key = new_node.node.properties?.target_company_key ?? rule_company_key
        new_node.node.properties.target_event_type = target_event_type

        return new_node
    })

    const enableBusinessGroupQueryOption = (box_settings?.enable_business_group_query_option ?? false)
    const useAdvancedMode = (box_settings?.use_advanced_mode ?? false)

    const [openChangeWarning, setOpenChangeWarning] = useState(false)
    const [open, setOpen] = useState(true)
    const [targetFieldMapping, dispatchTargetFieldMapping] = useReducer(dataFetchReducer,{
        fetchedData: null,
        isLoading: true,
        isError: false,
    })

    const getFilteredCompany = useCallback((targetCompanyKey) => {
        const effectiveKey = targetCompanyKey || rule_company_key

        return companyList.filter((comp) => (
            (effectiveKey === "every_company" || effectiveKey === comp.company_key)
        ))
    }, [rule_company_key, companyList])

    const getEventsForCompany = useCallback((targetCompanyKey) => {
        const filteredCompany = getFilteredCompany(targetCompanyKey)
        let seenEvents = new Set()
        return filteredCompany.flatMap((comp) =>
            comp.company_events
                .map(event => event.field_mapping.event_type)
                .filter(eventType => {
                    const eventEnum = eventType.enum;
                    const eventEnvironment = eventType.environment;
                    if (seenEvents.has(`${eventEnum}$#$${getRegionFromEnvironment(eventEnvironment)}`)) {
                        return false;
                    }
                    seenEvents.add(`${eventEnum}$#$${getRegionFromEnvironment(eventEnvironment)}`);
                    return true;
                })
        );
    }, [getFilteredCompany])

    const companyEvents = useMemo(() => (
        getEventsForCompany(nodeState?.node?.properties?.target_company_key)
    ), [getEventsForCompany, nodeState.node.properties.target_company_key])
    const uniqueRegions = new Set(companyEvents.map(e => getRegionFromEnvironment(e.environment)))
    const showRegionIcons = uniqueRegions.size > 1


    const clearEventTypeInfo = (new_node) => {
        const field = new_node.node.properties.fields?.[0] || {type: "dynamic"}
        new_node.node.properties.fields = [
            {...field, target_field_path: null, comparison: null, value: null}
        ]
    }

    const [pendingValue, setPendingValue] = useState(null)

    const changeTargetCompanyKey = (newValue, new_node) => {
        if (newValue === "every_company") {
            setObjectByPath(new_node.node, "properties.search_with_business_group_key", true)
        } else {
            setObjectByPath(new_node.node, "properties.search_with_business_group_key", false)
        }

        const nextEvents = getEventsForCompany(newValue)
        const currentTargetEvent = nodeState?.node?.properties?.target_event_type
        if (nextEvents.length === 1) {
            setObjectByPath(new_node.node, "properties.target_event_type", nextEvents[0])
        } else {
            setObjectByPath(new_node.node, "properties.target_event_type",
                nextEvents.find(event =>
                    event.enum === currentTargetEvent?.enum &&
                    getRegionFromEnvironment(event.environment) === getRegionFromEnvironment(currentTargetEvent?.environment)
                ) || null
            )
        }
        setObjectByPath(new_node.node, "properties.target_company_key", newValue)
        setNodeState(new_node)
    }
    const handleTargetCompanyKeyChange = (e, newValue) => {
        if(nodeState?.node?.properties?.fields.length === 0) {
            const new_node = _.cloneDeep(nodeState)
            changeTargetCompanyKey(newValue, new_node)
            return
        }
        else {
            setPendingValue({type: "target_company_key", value: newValue})
            setOpenChangeWarning(true)
        }
    }

    const changeTargetEventType = (newValue, new_node) => {
        setObjectByPath(new_node.node, "properties.target_event_type", newValue)
        setNodeState(new_node)
    }
    const handleTargetEventTypeChange = (e, newValue) => {
        if(nodeState?.node?.properties?.fields.length === 0) {
            const new_node = _.cloneDeep(nodeState)
            changeTargetEventType(newValue, new_node)
            return
        }
        else {
            setPendingValue({type: "target_event_type", value: newValue})
            setOpenChangeWarning(true)
        }
    }

    const getFieldMappingObjectFromEventType = useCallback((targetCompanyKey, targetEventEnum, targetEventEnvironment) => {
        if (!targetEventEnum) return null

        const filteredCompany = getFilteredCompany(targetCompanyKey)

        const matchingEvent = filteredCompany
            .flatMap(comp => comp.company_events)
            .find(event =>
                event.field_mapping?.event_type?.enum === targetEventEnum &&
                getRegionFromEnvironment(event.field_mapping?.event_type?.environment) === getRegionFromEnvironment(targetEventEnvironment)
            )

        return matchingEvent?.field_mapping ?? null
    }, [getFilteredCompany])


    const currentTargetEvent = nodeState?.node?.properties?.target_event_type ?? rule_event_type
    const currentTargetEventEnum = currentTargetEvent?.enum
    const currentTargetEventEnvironment = currentTargetEvent?.environment
    const currentTargetCompanyKey = nodeState?.node?.properties?.target_company_key

    useEffect(() => {
        if (!currentTargetEventEnum) return
        const targetFieldMappingObject = getFieldMappingObjectFromEventType(currentTargetCompanyKey, currentTargetEventEnum, currentTargetEventEnvironment)
        const targetFieldMappingKey = targetFieldMappingObject?.field_mapping_key
        const targetFieldMappingEnvironment = targetFieldMappingObject?.event_type?.environment

        dispatchTargetFieldMapping({type: "data_fetch_init"})
        const timer = setTimeout(() => {
            axios
            .get(`/dash/rule_engine/event_type/${currentTargetEventEnum}/field_mapping/${targetFieldMappingKey}?environment=${targetFieldMappingEnvironment}`)
            .then((response) => {
                let field_mapping = response.data
                dispatchTargetFieldMapping({type: "data_fetch_success", payload: field_mapping})
            })
            .catch((error) => {
                if ((error.response || {}).status === 403)
                    dispatchTargetFieldMapping({ type: "data_fetch_failure_403" });
                else if ((error.response || {}).status === 404)
                    dispatchTargetFieldMapping({ type: "data_fetch_failure_404" });
                else dispatchTargetFieldMapping({ type: "data_fetch_failure" });
            })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }, [currentTargetEventEnum,
        currentTargetEventEnvironment,
        currentTargetCompanyKey,
        getFieldMappingObjectFromEventType])

    const validateAllValues = () => {
        if (!nodeState.node.properties.target_company_key) return false
        if (!nodeState.node.properties.target_event_type) return false

        if ((nodeState.node.properties.fields || []).length === 0) return false

        let seenFields = new Set()
        for (let field of nodeState.node.properties.fields) {
            const stringifiedField = `${field.target_field_path},${field.comparison},${field.value},${field.type}`
            if (seenFields.has(stringifiedField)) {
                return false
            }
            seenFields.add(stringifiedField)
        }

        const mappings =  targetFieldMapping?.fetchedData?.mappings || nodeState.node.properties.target_event_type.field_mappings
        let hasInvalidFields = false
        if (mappings){
            hasInvalidFields = nodeState.node.properties.fields.some(field => {
                const targetType = mappings?.find(item => item.path === field.target_field_path)?.type;

                return (
                    !field?.target_field_path || field?.target_field_path.length === 0 || field?.comparison == null || field?.comparison === ""
                    || (!field?.value && field.value !== "")
                    || (field.type === "static" && !validateConstantValues(targetType, field.value))
                );
            })
        }

        if (hasInvalidFields) {
            return false
        }

        if (nodeState.node.properties.timedelta_value) {
            if (!validateConstantValues("timedelta", nodeState.node.properties.timedelta_value)) return false
        }


        return true
    }

    const handleValueChange = (path, val) => {
        let new_node = _.cloneDeep(nodeState)
        if (val === "P") val = null
        setObjectByPath(new_node.node,path,val)
        setNodeState(new_node)
    }

    const configurePayload = () => {
        const payload = _.cloneDeep(nodeState)
        const usedFieldPaths = new Set()

        let properties = payload.node.properties
        properties = trimNestedObject(properties)
        properties.fields = properties.fields.map(field => trimNestedObject(field))

        for (let field of properties.fields) {
            if (field.target_field_path) {
                usedFieldPaths.add(field.target_field_path)
            }
        }
        properties.target_event_type.field_mappings = targetFieldMapping.fetchedData.mappings.filter(field => usedFieldPaths.has(field.path))

        properties.target_event_type.region = getRegionFromEnvironment(properties.target_event_type.environment)
        delete properties.target_event_type.environment
        delete properties.target_event_type.description
        if (properties.search_with_business_group_key) {
            delete properties.target_company_key
        }

        payload.node.properties = properties
        return payload
    }

    const handleSave = () => {
        handleConfigurationClose()
        const payload = configurePayload()
        handleNodeChange(payload)
    }

    const handleFilterChange = (event, path) => {
        let new_node = _.cloneDeep(nodeState)

        const { value } = event.target

        if(!new_node.node.properties.filters){
            new_node.node.properties.filters = {}
        }

        if(!new_node.node.properties.filters[path]){
            new_node.node.properties.filters[path] =[]
        }

        new_node.node.properties.filters[path] = value;

        if(new_node.node.properties.filters[path].length === 0){
            delete new_node.node.properties.filters[path]
        }

        if(_.size(new_node.node.properties.filters)=== 0) {
            delete new_node.node.properties.filters
        }
        setNodeState(new_node)
    };

    let options_dictionary = {}
    for(let filter of settingsFilters){
        options_dictionary[filter.path] = {};
        for(let option of filter.options){
            options_dictionary[filter.path][option.enum] = option.description
        }
    }

    let filter_rendered_values = {}
    for(let filter of settingsFilters){
        let translated_values = []
        for(let selected_option of ((nodeState.node.properties.filters||{})[filter.path]||[])){
            translated_values.push(options_dictionary[filter.path][selected_option])
        }
        filter_rendered_values[filter.path] = translated_values.join(', ')
    }

    const handleClose = () => {
        handleConfigurationClose()
        setOpen(false)
    }

    const handleUpdateFields = (updatedFields) => {
        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node.properties, "fields", updatedFields)
        setNodeState(new_node)
    }

    const currentRuleEventChip = (
        <Chip
            label={t("Evento da Regra Atual")}
            size="small"
            style={{
                backgroundColor: "#0b1f821a",
                color: "#0b1f82",
                fontWeight: "bold",
                marginLeft: "12px"
            }}
        />
    )

    const renderCurrentEventTypeRegionIcon = (event_type) => {
        if (!event_type?.environment) return null
        const regionToIcon = {
            "us-east-1": usIcon,
            "sa-east-1": brIcon
        }

        const region = getRegionFromEnvironment(event_type.environment)
        const iconSrc = regionToIcon[region]
        if (!iconSrc) return null

        return (
            <img
                src={iconSrc}
                alt={region}
                style={{ width: 16, height: 16, borderRadius: "2px", marginLeft: "8px" }}
            />
        )
    }
    return(
            <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        minWidth: "300px",
                        maxWidth: "500px"
                    }
                }
            }}
        >
            <div style={{flexGrow:"1", padding: "20px", display:"flex", flexDirection:"column", width: "100%", overflow: "auto", overflowX: "hidden"}}>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <span className={["blueText", "titleSize"].join(" ")}>{t(node.node.description)}</span>
                    <Tooltip title={<div className="tooltipText"><ul>{node.node.helperText.map((help,index) => (<li key={index}>{t(help)}</li>))}</ul></div>}>
                        <HelpIcon style={{fontSize: "16px", display:"flex", margin:"auto 5px"}}/>
                    </Tooltip>
                </div>

                {nodeState && useAdvancedMode &&
                    <>
                    <p className={["blueText", "subtitleSize"].join(" ")} style={{width: "100%", margin: "0", marginTop: "12px"}}>{t("Selecionar Base Histórica")}</p>
                    {enableBusinessGroupQueryOption && <TextField
                        label={t("Cliente")}
                        className="filterTextbox"
                        size="small" fullWidth
                        value={nodeState.node.properties?.target_company_key}
                        onChange={(e) => {
                            handleTargetCompanyKeyChange(e, e.target.value);
                        }}
                        select
                        InputProps={{
                            readOnly: read_only
                        }}
                        style={{marginTop: "12px"}}
                    >
                        {[{name: "Todos no Grupo de Negócios", company_key: "every_company"}, ...[...companyList].sort((a, b) => (a.name || "").localeCompare(b.name || ""))].map((companyItem, idx) => {
                            return <MenuItem key={idx} value={companyItem.company_key}><em className="normalText">{t(companyItem.name)}</em></MenuItem>
                        })}
                    </TextField>}
                    <TextField
                        label={t("Tipo de Evento")}
                        className="filterTextbox"
                        size="small" fullWidth
                        value={`${nodeState.node.properties?.target_event_type?.enum}$#$${getRegionFromEnvironment(nodeState.node.properties?.target_event_type?.environment)}`}
                        onChange={(e) => {
                            const [selectedEnum, selectedRegion]= e.target.value.split("$#$")
                            const selectedEvent = companyEvents.find(event =>
                                event.enum === selectedEnum && getRegionFromEnvironment(event.environment) === selectedRegion
                            )
                            handleTargetEventTypeChange(e, selectedEvent)
                        }}
                        select
                        InputProps={{
                            readOnly: read_only
                        }}
                        style={{marginTop: "12px"}}
                        SelectProps={{
                            renderValue: (selectedValue) => {
                                const [selectedEnum, selectedRegion] = selectedValue.split("$#$")
                                const event = companyEvents.find(e => e.enum === selectedEnum && getRegionFromEnvironment(e.environment) === selectedRegion)
                                const isCurrentEvent = !isRulePiece &&(selectedEnum === rule_event_type?.enum && getRegionFromEnvironment(rule_event_type?.environment) === selectedRegion)
                                return (
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
                                        <em className="normalText">{event ? t(event.description) : ""}</em>
                                        {isCurrentEvent && currentRuleEventChip}
                                        {showRegionIcons && renderCurrentEventTypeRegionIcon(event)}
                                    </div>
                                )
                            }
                        }}
                        error={
                            !nodeState.node.properties?.target_event_type?.enum ||
                            !nodeState.node.properties?.target_event_type?.environment
                        }
                    >
                        {[...(companyEvents || [])].sort((a, b) => (a.description || "").localeCompare(b.description || "")).map((event, idx) => {
                            const isCurrentEvent = !isRulePiece && (event?.enum === rule_event_type?.enum && getRegionFromEnvironment(event?.environment) === getRegionFromEnvironment(rule_event_type?.environment))
                            return (
                                <MenuItem
                                    key={idx}
                                    value={`${event.enum}$#$${getRegionFromEnvironment(event.environment)}`}
                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                >
                                    <em className="normalText">{`${t(event.description)}`}</em>
                                    {isCurrentEvent && currentRuleEventChip}
                                    {showRegionIcons && renderCurrentEventTypeRegionIcon(event)}
                                </MenuItem>
                            )
                        })}
                    </TextField>
                    </>
                }

                <div className="internalCardContainer" style={{display:"flex", flexDirection: "column", margin: "0", width:"100%"}}>
                    <FieldsManager
                        read_only={read_only}
                        fields={nodeState.node.properties.fields}
                        onUpdate={handleUpdateFields}
                        rulesList={rulesList}
                        fieldMapping={targetFieldMapping}
                        userVariables={userVariables}
                        useAdvancedMode={useAdvancedMode}
                    />
                    <p className={["blueText", "subtitleSize"].join(" ")} style={{width: "100%", margin: "0", marginTop: "12px"}}>{t("Configurações")}</p>
                    {settingsFilters.map(filter =>
                        <FormControl key={filter.path} style={{textAlign:"center", width:"100%", margin:"0 auto 12px auto"}}>
                        <InputLabel id="demo-multiple-checkbox-label">{filter.description}</InputLabel>
                        <br></br>
                        <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        value={((nodeState.node.properties.filters||{})[filter.path]||[])}
                        onChange={(event) => handleFilterChange(event, filter.path)}
                        input={<Input />}
                        renderValue={(selected) => (filter_rendered_values[filter.path])}
                        MenuProps={MenuProps}
                        InputProps={{
                            readOnly: read_only
                        }}
                        >
                        {[...(filter.options || [])].sort((a, b) => (a.description || "").localeCompare(b.description || "")).map((option) => (
                            <MenuItem key={option.enum} value={option.enum} name={option.description}>
                            <Checkbox color="primary" checked={((nodeState.node.properties.filters||{})[filter.path]||[]).includes(option.enum)} />
                            <ListItemText primary={t(option.description)} />
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>)}
                    <TimeDeltaTextField
                        value={nodeState.node.properties.timedelta_value ? nodeState.node.properties.timedelta_value : ""}
                        error={nodeState.node.properties.timedelta_value ? !validateConstantValues("timedelta",nodeState.node.properties.timedelta_value) : false}
                        valueChangeFunction={(value) => handleValueChange("properties.timedelta_value", value)}
                        label={t("Período de Tempo considerado")}
                        read_only={read_only}
                    />
                </div>
                <div style={{display:"flex"}}>
                    <div
                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                        style={{width:"50%"}}
                        onClick={handleConfigurationClose}
                    >
                        {read_only ? "X" : t("discard")}
                    </div>
                    {!read_only &&
                    <div
                        className={
                            validateAllValues()
                            ?
                            ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                            :
                            ["button", "standard", "normalText", "normalMediumSize","disabled"].join(" ")}
                        style={{width:"50%"}}
                        onClick={
                            validateAllValues()
                            ? handleSave : null}
                    >
                        {t("save")}
                    </div>}
                </div>
            </div>
            {openChangeWarning && <Dialog
                open={openChangeWarning}
                onClose={() => {
                    setOpenChangeWarning(false)
                    setPendingValue(null)
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            minWidth: "250px",
                            maxWidth: "350px"
                        }
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    {t("Alterar o tipo de evento limpará os campos configurados")}
                </DialogTitle>
                <DialogContent>
                    <Typography id="alert-dialog-description">
                        {t("Deseja continuar?")}
                    </Typography>
                </DialogContent>
                <DialogActions style={{ display: "flex", padding: "16px 24px", width: "100%" }}>
                    <div
                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                        style={{ width: "50%" }}
                        onClick={() => {
                            setOpenChangeWarning(false)
                            setPendingValue(null)
                        }}
                    >
                        {t("Não")}
                    </div>
                    <div
                        className={["button", "standard", "normalText", "normalMediumSize"].join(" ")}
                        style={{ width: "50%" }}
                        onClick={() => {
                            const new_node = _.cloneDeep(nodeState)
                            clearEventTypeInfo(new_node)

                            if (pendingValue.type === "target_company_key") {
                                changeTargetCompanyKey(pendingValue.value, new_node)
                            } else if (pendingValue.type === "target_event_type") {
                                changeTargetEventType(pendingValue.value, new_node)
                            }

                            setOpenChangeWarning(false)
                            setPendingValue(null)
                        }}
                    >
                        {t("Sim")}
                    </div>
                </DialogActions>
            </Dialog>}
        </Dialog>
    )
}

function isNodeV1(node){
    const properties = node?.node?.properties
    return (!Array.isArray(properties?.fields) && (Array.isArray(properties?.field_paths) || Array.isArray(properties?.static_fields)))
}

function nodeToV2(node){
    const properties = node?.node?.properties
    const isV1 = isNodeV1(node)

    if (isV1) {
        node.node.properties.fields = translatePathsV1toV2(properties?.field_paths, properties?.static_fields)
        delete node.node.properties.field_paths
        delete node.node.properties.static_fields
        delete node.node.properties.match_number
    }
    return node
}

function translatePathsV1toV2(field_paths, static_fields){
    const newFields = []

    if(Array.isArray(field_paths)){
        field_paths.forEach(field => {
            if(typeof field === "string" && field.trim() !== ""){
                newFields.push({
                    target_field_path: field,
                    value: field,
                    comparison: "equal",
                    type: "dynamic"
                })
            }
        })
    }

    if(Array.isArray(static_fields)){
        static_fields.forEach(field => {
            const type = field?.user_variable_name != null ? "user_variable" : "static"
            if(field && field.field_path) {
                newFields.push({
                    target_field_path: field.field_path,
                    comparison: field.comparison || "equal",
                    value: (type === "user_variable") ? field.user_variable_name : field.value,
                    type: type
                })
            }
        })
    }

    return newFields
}

function toIsoDateTime(formattedTime) {
    if (!formattedTime) return formattedTime;
    if (formattedTime.length < 19) return formattedTime;
    const year   = formattedTime.substring(6, 10);
    const month  = formattedTime.substring(3, 5);
    const day    = formattedTime.substring(0, 2);
    const hour   = formattedTime.substring(11, 13);
    const minute = formattedTime.substring(14, 16);
    const second = formattedTime.substring(17, 19);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.000Z`;
}

function toFormattedDateTime(isoTime) {
    if (!isoTime) return isoTime;
    if (isoTime.length < 24) return isoTime;
    const year   = isoTime.substring(0, 4);
    const month  = isoTime.substring(5, 7);
    const day    = isoTime.substring(8, 10);
    const hour   = isoTime.substring(11, 13);
    const minute = isoTime.substring(14, 16);
    const second = isoTime.substring(17, 19);
    return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
}

export function FieldsManager(props){
    const { t } = useTranslation()

    const {
        read_only,
        fields,
        onUpdate,
        rulesList,
        fieldMapping,
        useAdvancedMode
    } = props

    const handleAdd = () => {
        onUpdate([...fields, {target_field_path: "", comparison: null, value: null, type: "dynamic"}])
    }

    const handleRemove = (index) => {
        const newFields = [...fields]
        newFields.splice(index,1)
        onUpdate(newFields)
    }

    const handleUpdate = (index, updateData) => {
        const newFields = [...fields]
        newFields[index] = {...newFields[index], ...updateData}
        onUpdate(newFields)
    }

    const getComparisonSetForType = (type) => {
        const completeComparisonSet = [
            {value: "greater", label: "Maior que"},
            {value: "less", label: "Menor que"},
            {value: "greater_or_equal", label: "Maior ou igual a"},
            {value: "less_or_equal", label: "Menor ou igual a"},
            {value: "equal", label: "Igual a"},
            {value: "different", label: "Diferente de"}

        ]

        const reducedComparisonSet = [
            {value: "equal", label: "Igual a"},
            {value: "different", label: "Diferente de"}
        ]

        switch(type){
            case "string":
                return reducedComparisonSet
            case "bool":
                return reducedComparisonSet
            case "datetime":
                return completeComparisonSet
            default:
                return completeComparisonSet
        }
    }

    const stringifyField = (f) => `${f.target_field_path},${f.comparison},${f.value},${f.type}`;
    const duplicateSignatures = new Set(
        fields.map(stringifyField).filter((sig, index, arr) => arr.indexOf(sig) !== index)
    )

    return (<>
        <p className={["blueText", "subtitleSize"].join(" ")} style={{width: "100%", margin:"12px 0 6px 0"}}>{t('fields')}</p>
        {fields.map((field,index) =>{
            const mappings = fieldMapping?.fetchedData?.mappings || []
            const mappingsForSelect = [...mappings]
                .filter((mappingField) => mappingField.type === "number" || mappingField.type === "string" || mappingField.type === "datetime")
                .sort((a, b) => (a.description || "").localeCompare(b.description || ""))
            const pathVariableType = mappings.find(item => item.path === field.target_field_path)?.type ?? null

            const currentEventFields = rulesList.fields_mapper_list || []
            const possibleMappings = currentEventFields.filter((mapping) => {
                if(useAdvancedMode) {
                    return !pathVariableType || mapping.type === pathVariableType;
                } else {
                    return mapping.path === field.target_field_path;
                }
            })

            const comparisonSet = getComparisonSetForType(pathVariableType)
            const isDuplicate = duplicateSignatures.has(stringifyField(field))
            const isFieldMappingAvailable = fieldMapping?.fetchedData?.mappings && !fieldMapping?.isLoading

            return (<div style={{display: "flex", gap:0, width: "100%", margin: "6px 0", alignItems: "center", minWidth: 0}} key={`field-${index}`}>
                <div style={{display:"flex", flexDirection: "column", margin:"3px auto", width:"100%", minWidth: 0}}>
                    <div style={{display: "flex", width: "100%", alignItems: "center", minWidth: 0}}>
                        <TextField
                            label={t("Campo da Base Histórica")}
                            error={isFieldMappingAvailable && (field.target_field_path === "" || field.target_field_path == null || isDuplicate)}
                            className="filterTextbox"
                            size="small" fullWidth
                            value={!isFieldMappingAvailable ? "loading" : (field?.target_field_path ?? "")}
                            onChange={(e) => {
                                handleUpdate(index, {
                                    target_field_path: e.target.value,
                                    comparison: null,
                                    value: (!useAdvancedMode && field.type === "dynamic") ? e.target.value : null
                                })
                            }}
                            select
                            InputProps={{
                                readOnly: read_only,
                                style: { overflow: "hidden", textOverflow: "ellipsis" }
                            }}
                            disabled={!isFieldMappingAvailable || read_only}
                        >
                            {!isFieldMappingAvailable ? (
                                <MenuItem value="loading">
                                    <em className="normalText">{t("Carregando...")}</em>
                                </MenuItem>
                            ) : (
                                mappingsForSelect.map((mappingField, field_index) => (
                                    <MenuItem key={`target-field-${field_index}`} value={mappingField.path}>
                                        <em className="normalText">{t(mappingField.description) + " ("+ t(translateType(mappingField.type))+ ")"}</em>
                                    </MenuItem>
                                ))
                            )}
                        </TextField>
                    </div>
                    <TextField
                        label={t("Comparação")}
                        error={field?.target_field_path && (field?.comparison === "" || field?.comparison == null || isDuplicate)}
                        className="filterTextbox"
                        size="small" fullWidth
                        select
                        value={field?.comparison || ""}
                        onChange={(e) => {
                            handleUpdate(index, {comparison: e.target.value})
                        }}
                        disabled={!fieldMapping?.fetchedData?.mappings || fieldMapping.isLoading || !field?.target_field_path || field?.target_field_path === "" || read_only}
                        InputProps={{
                            readOnly: read_only
                        }}
                    >
                        {[...comparisonSet].sort((a, b) => (a.label || "").localeCompare(b.label || "")).map((element) => {
                            return <MenuItem key={`comparison-${element.value}`} value={element.value}><em className="normalText">{t(element.label)}</em></MenuItem>
                        })}
                    </TextField>
                    <RowValueInput
                        field={field}
                        handleUpdate={(newField) => handleUpdate(index, newField)}
                        pathVariableType={pathVariableType}
                        userVariables={props.userVariables}
                        read_only={read_only}
                        possibleMappings={possibleMappings}
                        isTargetFieldDisabled={!fieldMapping?.fetchedData?.mappings}
                        useAdvancedMode={useAdvancedMode}
                        isDuplicate={isDuplicate}
                    />
                </div>
                {!read_only &&
                <Tooltip title={t("Remover Campo")}>
                <DeleteIcon
                    style={{cursor:"pointer", margin:"5px", height: "fit-content", fill: colorVelvet}}
                    onClick={() => handleRemove(index)}
                />
                </Tooltip>
                }
            </div>)
        })}
        {!read_only && <div
            style={{cursor:"pointer", margin:"5px auto"}}
            onClick={handleAdd}
            className={["blueText", "normalSMallSize"].join(" ")}
        >
            {t("+ ADICIONAR NOVO")}
        </div>}
    </>)
}

export function RowValueInput(props) {
    const { t } = useTranslation()
    const {
        handleUpdate,
        field,
        read_only,
        pathVariableType,
        userVariables,
        possibleMappings,
        isTargetFieldDisabled,
        useAdvancedMode,
        isDuplicate
    } = props

    const [valueTypeMenuAnchorEl, setValueTypeMenuAnchorEl] = useState(null)

    const handleValueTypeMenuClick = (event) => {
        setValueTypeMenuAnchorEl(event.currentTarget)
    }

    const handleValueTypeChange = (newType) => {
        const defaultTarget = (!useAdvancedMode && newType === "dynamic") ? field.target_field_path : null
        handleUpdate({
            type: newType,
            value: defaultTarget,
        })
        setValueTypeMenuAnchorEl(null)
    }

    const valueTypeToIcon = {
        static: ConstantNumberWhite,
        user_variable: VariableWhiteIcon,
        dynamic: RestoreWhite
    }
    const type = field?.type
    const comparison = field?.comparison

    const getConstantValueInput = (inputType) => {
        switch(inputType) {
            case "number":
                return  (<TextField
                    label={t('Valor')}
                    error={comparison && (!validateConstantValues("number", field.value) || isDuplicate)}
                    value={field?.value || ""}
                    className="filterTextBox"
                    style={{height: 48}}
                    size="small" fullWidth
                    type="number"
                    onChange={(e) => {
                        handleUpdate({value: Number(e.target.value)})
                    }}
                    InputProps={{readOnly: read_only}}
                    disabled={isTargetFieldDisabled || !comparison || read_only}
                />)
            case "datetime":
                const datetimeError = comparison && !validateConstantValues("datetime", field.value ? field.value : false)
                return (<InputMask
                    label={t('Valor')}
                    style={{textAlign:"center", width:"100%", margin:"3px auto", height: 48}}
                    error={datetimeError || isDuplicate}
                    value={toFormattedDateTime(field?.value) || ""}
                    {...getConstantTextFields('datetime').props}
                    onChange={(e) => {
                        handleUpdate({value: toIsoDateTime(e.target.value)})
                    }}
                    InputProps={{
                        readOnly: read_only
                    }}
                    disabled={isTargetFieldDisabled || !comparison || read_only}
                    helperText={datetimeError ? t("Formato esperado: DD/MM/AAAA HH:MM:SS") : null}
                />)
            case "string":
                return (<TextField
                    label={t('Valor')}
                    error={comparison && (!validateConstantValues("string", field.value) || isDuplicate)}
                    value={field?.value || ""}
                    className="filterTextBox"
                    style={{height: 48}}
                    size="small" fullWidth
                    type="string"
                    onChange={(e) => {
                        handleUpdate({value: e.target.value})
                    }}
                    InputProps={{readOnly: read_only}}
                    disabled={isTargetFieldDisabled || !comparison || read_only}
                />)
            default:
                return (<TextField
                    label={t('Valor')}
                    error={comparison && isDuplicate}
                    value={field?.value || ""}
                    className="filterTextBox"
                    style={{height: 48}}
                    size="small" fullWidth
                    type="string"
                    onChange={(e) => {
                        handleUpdate({value: e.target.value})
                    }}
                    InputProps={{readOnly: read_only}}
                    disabled={isTargetFieldDisabled || !comparison || read_only}
                />)
        }
    }

    const renderInput = () => {
        switch(type) {
            case "dynamic":
                if (!useAdvancedMode) {
                    const selectedMapping = possibleMappings[0]
                    const displayValue = selectedMapping
                        ? `${t(selectedMapping.description)} (${t(translateType(selectedMapping.type))})`
                        : field.value || "";

                    return (
                        <TextField
                            error={false}
                            className="filterTextbox"
                            size="small" fullWidth
                            label={t("Campo do Evento Analisado")}
                            value={displayValue}
                            disabled
                        />
                    )
                }
                else {
                    const displayValue = possibleMappings.some((mapping)=> mapping.path === field?.value) ?
                        field?.value ?? ""  : ""
                    return (<TextField
                            error={comparison && (field?.value == null || field?.value === "" || isDuplicate)}
                            className="filterTextbox"
                            size="small" fullWidth
                            label={t("Campo do Evento Analisado")}
                            value={displayValue}
                            select
                            onChange={(e) => {
                                handleUpdate({value: e.target.value})
                            }}
                            disabled={isTargetFieldDisabled || !comparison || read_only}
                        >
                            {possibleMappings.length === 0 ? (
                                <MenuItem value="" disabled>
                                    <em className="normalText">{t("Nenhum campo disponível para comparação")}</em>
                                </MenuItem>
                            ) : (
                                [...possibleMappings].sort((a, b) => (a.description || "").localeCompare(b.description || "")).map((mapping) => (
                                    <MenuItem key={mapping.path} value={mapping.path}>
                                        <em className="normalText">
                                            {`${t(mapping.description)} (${t(translateType(mapping.type))})`}
                                        </em>
                                    </MenuItem>
                                ))
                            )}
                    </TextField>)
                }
            case "user_variable":
                return (<TextField
                    label={t('Variável')}
                    error={comparison && (field?.value == null || field?.value === "" || isDuplicate)}
                    value={field.value ?? ""}
                    style={{textAlign:"center"}}
                    select fullWidth
                    onChange={(e) => {
                        handleUpdate({value: e.target.value})
                    }}
                    disabled={isTargetFieldDisabled || !comparison || read_only}
                >
                    {[...userVariables]
                        .filter((variable) => variable.variable_type === pathVariableType)
                        .sort((a, b) => (a.variable_name || "").localeCompare(b.variable_name || ""))
                        .map((variable, index) => (
                            <MenuItem key={index} value={variable.variable_name}>{variable.variable_name}</MenuItem>
                        ))}
                </TextField>)
            case "static":
                return getConstantValueInput(pathVariableType)
            default:
                return <></>
        }
    }

    return (
        <div style={{width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, minHeight: 48}}>
            {renderInput()}
            <Tooltip title="Escolher tipo de Valor">
                <span>
                    <Button
                        variant='contained'
                        sx={[{'&:hover': {backgroundColor: "#020f4d"}}, {maxWidth: 24, height: "32px", backgroundColor: "#0b1f82"}]}
                        onClick={handleValueTypeMenuClick}
                        disabled={!comparison || read_only}
                    >
                        <img src={valueTypeToIcon[type]} style={{width: 20, height: 20}} alt="Escolher tipo de Valor"/>
                    </Button>
                </span>
            </Tooltip>

            <Menu
                anchorEl={valueTypeMenuAnchorEl}
                open={Boolean(valueTypeMenuAnchorEl)}
                onClose={() => setValueTypeMenuAnchorEl(null)}
            >
                <MenuItem onClick={() => handleValueTypeChange("static")}>
                    {t("Valor Constante")}
                </MenuItem>
                <MenuItem onClick={() => handleValueTypeChange("user_variable")}>
                    {t("Variável de Usuário")}
                </MenuItem>
                <MenuItem onClick={() => handleValueTypeChange("dynamic")}>
                    {t("Campo do Evento Analisado")}
                </MenuItem>
            </Menu>
        </div>
    )
}

export class EventFieldCounterBoxClass {
    constructor(rulesContext){
        this.rulesContext = rulesContext
    }
    validate(node){
        const validateNode = _.cloneDeep(node)
        const isV1 = isNodeV1(node)
        nodeToV2(validateNode)
        let put_error = false
        let alerts = []

        //Validate if node has one or two children
        if((validateNode.node.children || []).length !== 0){
            put_error = true
            alerts.push("Este nó não deve possuir filhos")
        }

        if(!isV1 && !validateNode.node.properties.target_company_key){
            put_error = true
            alerts.push("Deve ser selecionada uma base histórica para este nó")
        }

        if(!isV1 && !validateNode.node.properties.target_event_type){
            put_error = true
            alerts.push("Deve ser selecionado um tipo de evento para este nó")
        }

        if((validateNode.node.properties.fields || []).length === 0){
            put_error = true
            alerts.push("Este nó deve possuir ao menos um campo configurado")
        }
        else{
            let seenFields = new Set()
            let hasDuplicates = false
            for(let field of validateNode.node.properties.fields){
                const stringifiedField = `${field.target_field_path},${field.comparison},${field.value},${field.type}`
                if(seenFields.has(stringifiedField)){
                    hasDuplicates = true
                    break
                }
                seenFields.add(stringifiedField)
            }

            if (hasDuplicates) {
                put_error = true
                alerts.push("Este nó não deve ter Campos da base histórica duplicados")
            }



            const targetMappings = validateNode.node.properties.target_event_type?.field_mappings
            let hasInvalidFields = false
            if (targetMappings) {
                hasInvalidFields = validateNode.node.properties.fields.some(field => {
                    const fieldType = targetMappings.find(item => item.path === field.target_field_path)?.type

                    return (
                        !field.target_field_path || field.target_field_path.length === 0 || field.comparison == null || field.comparison === ""
                        || (!field?.value && field.value !== "")
                        || (field.type === "static" && !validateConstantValues(fieldType, field.value))
                    )
                })

                if (hasInvalidFields){
                    put_error = true
                    alerts.push("Todos os Campos deste nó devem ter opções válidas")
                }
            }
        }

        if (validateNode.node.properties.timedelta_value) {
            if (!validateConstantValues("timedelta",validateNode.node.properties.timedelta_value)){
                put_error = true
                alerts.push("Deve ser fornecido um período de tempo válido")
            }
        }
        //Validate if parent is valid
        if (validateNode.parentNode != null) {
            if(validateNode.parentNode.on_error){
                put_error = true
                alerts.push("O nó superior está inválido")
            }
        }
        return {validated: !put_error, alerts: alerts}
    }

    getType(node){
        return "number"
    }
}
